import { SyntheticEvent, useRef, useState } from 'react';
import { useNavigate } from 'react-router';

import { useAppSelector } from 'app/hooks';

import useAuth from './useAuth';

export default function useHeaderMenu() {
  const navigate = useNavigate();

  const { merchant } = useAppSelector((store) => store.merchant);
  const { logout } = useAuth();

  const anchorRef = useRef<any>(null);
  const [open, setOpen] = useState(false);
  const [value, setValue] = useState(0);
  const [selectedIndex, setSelectedIndex] = useState(0);

  const handleChange = (event: SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const handleClose = (event: MouseEvent | TouchEvent) => {
    if (anchorRef.current?.contains(event.target)) {
      return;
    }
    setOpen(false);
  };

  const handleListItemClick = (_: React.MouseEvent<HTMLDivElement>, index: number, route: string = '') => {
    setSelectedIndex(index);
    if (route && route !== '') {
      navigate(route);
      handleToggle();
    }
  };

  const handleLogout = async () => {
    try {
      await logout();
      navigate(`/login`, {
        state: {
          from: ''
        }
      });
    } catch (err) {
      console.error(err);
    }
  };

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  return {
    anchorRef,
    merchant,
    open,
    selectedIndex,
    value,
    handleChange,
    handleClose,
    handleListItemClick,
    handleLogout,
    handleToggle
  };
}
